import merge from 'deepmerge';
import system from '../semantics/web/semantics.js';
export default function extendSemantics() {
  var systemOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return merge(system, systemOptions);
}